import logo from '../assets/reilm-logo.svg'
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as AvatarIcon } from  '../assets/avatar1.svg'
import { useAuth } from './auth/AuthContext'

const AppNavbar = () => {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  // M-4.1 (13.08 reply): Микола scoped the "Upgrade" relabel to a trial user only — he never
  // asked for the old "Pricing" link to disappear for anyone else. A paying subscriber
  // (active, past_due, or any other non-trial status the schema carries) still needs a path
  // to /pricing for Change Plan, so that link stays for real-but-non-trial subscriptions.
  // A legacy account with no subscription record at all gets neither link, same as before.
  const isTrialing = user?.subscription?.status === 'trialing'
  const hasNonTrialSubscription = Boolean(user?.subscription?.status) && !isTrialing

  return (
    <header className="min-h-[72px] md:h-[96px] bg-brand-pageFill border-b border-black/5">
      {/* 15.08: in the trialing state the row's own content (logo + Pipeline + Upgrade pill +
          Logout) measures ~362.5px wide plain, so it only actually breaches the viewport below
          that — 320px overflows by ~42px, 375px does not (measured, not assumed: forcing
          flex-nowrap at 375 puts Logout's right edge at 362.55, ~12px inside the edge, matching
          the existing fix that already covers 375). Plain `flex-wrap` wraps earlier than that,
          at ~379px, because it compares against the *padded* content box rather than the
          viewport — it would change 375's established single-row layout too, which nothing
          reported as broken. `max-[365px]` targets the actual failure width instead (with a
          margin over the measured 362.55px boundary, and low enough to also catch 360px, a
          common Android width that was never checked here before). */}
      <div className="h-full flex flex-nowrap max-[365px]:flex-wrap items-center justify-between gap-2 px-4 md:px-6 max-[365px]:py-2">
        <div className="flex items-center gap-16">
          <img src={logo} alt="logo" className="w-[120px] md:w-[160px] shrink-0" />
        </div>

        {/* The logo is deliberately inert in here (Микола), so this nav is the only way out of
            the platform. */}
        <nav className="flex items-center gap-6 md:gap-12 text-[15px] md:text-[18px] font-medium">
          <Link
            to="/pipeline"
            className="text-brand-dark hover:text-brand-green transition font-semibold"
          >
            Pipeline
          </Link>
          {hasNonTrialSubscription && (
            <Link
              to="/pricing"
              className="text-brand-dark hover:text-brand-green transition font-semibold"
            >
              Pricing
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-2 md:gap-4 shrink-0">
          {/* Own gap-2 (8px) rather than the container's, which grows to 16px at md — his spec
              gives 8px flat, not a value that step up with breakpoint. */}
          <div className="flex items-center gap-2">
            {isTrialing && (
              <Link
                to="/pricing"
                className="w-[100px] h-[40px] flex items-center justify-center shrink-0 rounded-full border border-brand-fieldBdr text-brand-dark text-[14px] font-semibold hover:border-brand-green hover:text-brand-green transition-colors"
              >
                Upgrade
              </Link>
            )}
            <AvatarIcon className="hidden sm:block" />
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="text-brand-dark hover:text-brand-green text-[15px] md:text-[16px] font-semibold transition"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  )
}

export default AppNavbar